import { render, staticRenderFns } from "./PublicationCreateFacilities.vue?vue&type=template&id=f3da1f06&scoped=true&"
import script from "./PublicationCreateFacilities.vue?vue&type=script&lang=js&"
export * from "./PublicationCreateFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3da1f06",
  null
  
)

export default component.exports